import React, { useEffect, useRef, useState } from 'react'
import { B64toBlob } from '../../utils'

export const CustomUploadCamera = props => {
  const takePicture = useRef(null)
  const [activeCamera, setActiveCamera] = useState(false)

  useEffect(() => {
    if (!activeCamera) {
      // console.log("Active camera*****")
      setActiveCamera(true)
      takePicture.current.click()
    }
  }, [takePicture.current])

  // const turnTob64 = (e, event) => {
  //   event.target.value = null
  //   let base64 = e.target.result
  //   base64 = base64.split(',')
  //   // console.log("----------------Base g4 IMAGE-------------------: ", base64)
  //   const blob = B64toBlob(base64[1], 'image/jpeg');
  //   props.onCapture(blob)
  // }

  let handleCapture = async (event) => {
    if (event.target.files && event.target.files[0]) {
      let archivo = event.target.files[0];
      const blob = await comprimirImagen(archivo, parseInt(30));
      // console.log("Comprimir imaen response: ",blob)
      props.onCapture(blob)
      // 
      //   let readerToSend = new FileReader()
      //   readerToSend.onload = (e) => {
      //     turnTob64(e, event)
      //     readerToSend.abort();
      //   }
      //   readerToSend.readAsDataURL(event.target.files[0]); //this is to read as b64        
    }
  }

  return (
    <div style={{
      textAlign: 'center', display: 'flex',
      alignItems: 'center', flexDirection: 'column'
    }}>
      <input
        type='file'
        hidden
        multiple
        accept='image/*'
        capture='environment'
        onChange={handleCapture}
        ref={takePicture} />
    </div>
  );
}

const comprimirImagen = (imagenComoArchivo, porcentajeCalidad) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const imagen = new Image();
    imagen.onload = () => {
      canvas.width = imagen.width;
      canvas.height = imagen.height;
      canvas.getContext("2d").drawImage(imagen, 0, 0);
      canvas.toBlob(
        (blob) => {
          // console.log("Response convert: ",blob)
          if (blob === null) {
            return reject(blob);
          } else {
            resolve(blob);
          }
        },
        "image/jpeg",
        porcentajeCalidad / 100
      );
    };
    imagen.src = URL.createObjectURL(imagenComoArchivo);
  });
};
